<div class="m-4">
    <div class="row px-3">
      <div class="col-11">
        <p class="titleFont">
          {{ "label.claim.claimDetails.positionMainDuties" | translate }}
        </p>
      </div>
      <div class="col-1 Image">
        <img class="editIconPro" src="{{ editIcon }}" alt="" />
      </div>
    </div>
    <div class="px-3 py-3">
      <div class="row mb-2">
        <div class="col-12">
          <dxc-textarea
          *ngIf="positionBeforeDisabilityFlag"
          class="textArea"
          (valueChange)="onChangeValue($event)"
          [value]="positionBeforeDisability"
          [disabled]="true"
        >
        </dxc-textarea>
        <dxc-textarea
          *ngIf="positionAfterDisabilityFlag"
          class="textArea"
          (valueChange)="onChangeValue($event)"
          [value]="positionAfterDisability"
          [disabled]="true"
        >
        </dxc-textarea>
          <div class="row">
            <div class="col-12 text-right">
              <p class="characterFont">{{ "label.claim.claimDetails.characters" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row endButtons">
        <custom-button
          class="saveBtn"
          label="{{ 'label.claim.claimDetails.save' | translate }}"
          mode="primary"
          margin="xsmall"
          (onClick)="onCloseDialog()"
        >
        </custom-button>
        <custom-button
          class="cancelBtn"
          label="{{ 'label.claim.claimDetails.cancel' | translate }}"
          mode="secondary"
          margin="xsmall"
          (onClick)="onCloseDialog()"
        >
        </custom-button>
      </div>
    </div>
  </div>
  